import Barcode from './components/BarcodeGen'

function App() {
  return (
    <Barcode/>
  );
}

export default App;
